import NumberFlow from "@number-flow/react";
import { USD } from "constants/currency";
import { EN_US } from "constants/javaLocales";
import { currency, CURRENCY_CODE_COUNTRY_CODE_MAP } from "utils/Currency";

export const AnimatedNumbers = ({
  amount,
  currencyCode = USD,
}: {
  amount: number;
  currencyCode?: string;
}) => {
  const numberFormat = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: currencyCode || USD,
  });
  const currencyAmount = numberFormat.formatToParts(amount || 0);
  const fraction = currencyAmount.filter(({ type }) => type === "fraction");
  const { value: decimal } = fraction?.[0] || {};

  const localAmount =
    (amount || 0) > 0 ? Math.floor(amount) : Math.ceil(amount || 0);

  const numberToShow = currency({
    amount: localAmount,
    currencyCode: currencyCode,
    maximumFractionDigits: 0,
  });

  if (process.env.NODE_ENV === "test") {
    return <span>{`${numberToShow}.${decimal}`}</span>;
  }

  return (
    <span>
      <span className="t-sr-only">{`${numberToShow}.${decimal}`}</span>
      <NumberFlow
        aria-hidden
        value={localAmount}
        locales={CURRENCY_CODE_COUNTRY_CODE_MAP[currencyCode] || EN_US}
        format={{
          useGrouping: true,
          style: "currency",
          currency: currencyCode,
          maximumFractionDigits: 0,
        }}
        className="pointer-events-none"
        willChange
      />
      <sup aria-hidden className="-t-top-[0.2em] t-no-underline">
        .{decimal}
      </sup>
    </span>
  );
};
